import { useMemo } from "react";
import { usePathname, useLocalSearchParams } from "expo-router";
import { View, Text } from "@src/components";
import { getWebBreadcrumbs } from "@src/utils/web-breadcrumbs";
import { NavPressable } from "@src/components/NavPressable";
import { useTenantId } from "@src/features/tenants";
import { useSites } from "@src/features/cameras/hooks/useSites";

export function Breadcrumbs() {
  const pathname = usePathname();
  const contextTenantId = useTenantId();
  const params = useLocalSearchParams<{
    tenantId?: string;
    siteId?: string;
    siteIds?: string;
    reportId?: string;
    cameraKey?: string;
    userId?: string;
    // Traffic-flow configure page passes the site as a `site` query param.
    site?: string;
  }>();

  const siteId = params.site ?? params.siteId;
  const { sites } = useSites({ enabled: !!siteId });
  const siteName = useMemo(() => sites?.find((s) => String(s.siteId) === siteId)?.siteName, [sites, siteId]);

  const breadcrumbs = getWebBreadcrumbs({
    pathname,
    tenantId: params.tenantId || contextTenantId || undefined,
    siteId: siteId ?? params.siteIds,
    reportId: params.reportId,
    cameraKey: params.cameraKey,
    userId: params.userId,
    siteName,
  });

  return (
    <View flexDirection="row" alignItems="center" gap="md">
      {breadcrumbs.map((item, index) => (
        <View key={index} flexDirection="row" alignItems="center" gap="md">
          {index > 0 && (
            <Text textStyle="sm/regular" color="textMuted">
              /
            </Text>
          )}
          {item.href ?
            <NavPressable href={item.href as never}>
              <Text textStyle="sm/regular" color="text">
                {item.label}
              </Text>
            </NavPressable>
          : <Text textStyle="sm/bold" color="text">
              {item.label}
            </Text>
          }
        </View>
      ))}
    </View>
  );
}
